export const businessMessages = Object.freeze({
  password: {
    USER_NAME_DOES_NOT_EXIST: 'Username does not exist.',
    TEMPORARY_PASSWORD: 'Temporary password is expired. Please resend your password reset request.',
    PASSWORD_MISMATCH: 'Passwords do not match.',
    UNEXPECTED_EXCEPTION: 'An unexpected error occurred.  Please try again later.',
    RESET_SUCCESS_MESSAGE: 'Your password was successfully reset.',
    RESET_FAILURE_MESSAGE:
      'An unexpected error occurred while resetting your password. Please try again later.',
    NEW_PASSWORD_LENGTH_EXCEPTION: 'New password is not long enough.',
    NEW_PASSWORD_LOWERCASE_EXCEPTION: 'New password must contain at least 1 lowercase character.',
    NEW_PASSWORD_UPPERCASE_EXCEPTION: 'New password must contain at least 1 uppercase character.',
    NEW_PASSWORD_SYMBOL_EXCEPTION: 'New password must contain at least 1 symbol.',
    NEW_PASSWORD_NUMBER_EXCEPTION: 'New password must contain at least 1 number.',
  },
  accountSettings: {
    NAME_CHANGE_EXCEPTION: 'We cannot update your name at this time. Please try again later.',
    NAME_CHANGE_SUCCESS: 'Your name has been successfully updated.',
  },
  fileDownload: {
    FAILED: 'Document failed to download. Please try again later.',
  },
  confirmInvite: {
    USER_ALREADY_CONFIRMED: 'Your invite is already confirmed.',
  },
})
